import React from 'react';
import { Box, Skeleton, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

const SkeletonCard = styled(Box)(({ theme }) => ({
  background: 'rgba(255, 255, 255, 0.1)',
  backdropFilter: 'blur(10px)',
  borderRadius: theme.shape.borderRadius * 2,
  height: '100%',
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'translateY(-4px)',
  },
}));

const ProjectsSkeleton = () => {
  return (
    <Box sx={{ width: '100%' }}>
      {/* Header Skeleton */}
      <Box sx={{ mb: 4 }}>
        <Skeleton variant="text" width={300} height={48} />
        <Skeleton variant="text" width={200} height={24} sx={{ mb: 3 }} />
        
        {/* Summary Cards */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          {[1, 2].map((item) => (
            <Grid item xs={12} sm={6} md={3} key={item}>
              <SkeletonCard sx={{ p: 2 }}>
                <Skeleton variant="text" width={120} height={24} />
                <Skeleton variant="text" width={150} height={32} />
              </SkeletonCard>
            </Grid>
          ))}
        </Grid>

        {/* Filters Skeleton */}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 3 }}>
          <Skeleton variant="rounded" width={200} height={40} />
          <Skeleton variant="rounded" width={150} height={40} />
          <Skeleton variant="rounded" width={150} height={40} />
          <Skeleton variant="rounded" width={150} height={40} />
        </Box>
      </Box>

      {/* Projects Grid Skeleton */}
      <Grid container spacing={3}>
        {[1, 2, 3, 4, 5, 6].map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item}>
            <SkeletonCard>
              <Skeleton variant="rectangular" height={200} />
              <Box sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Skeleton variant="text" width={60} />
                  <Skeleton variant="rounded" width={80} height={24} />
                </Box>
                <Skeleton variant="text" width="80%" height={28} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="60%" />
                <Box sx={{ mt: 2 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Skeleton variant="text" width="100%" />
                      <Skeleton variant="text" width="80%" />
                    </Grid>
                    <Grid item xs={6}>
                      <Skeleton variant="text" width="100%" />
                      <Skeleton variant="text" width="80%" />
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </SkeletonCard>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ProjectsSkeleton;